//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false*/

(function() {
  angular.module('curalate')
        .directive('taggerTag', () => ({
          restrict: 'E',
          scope: {
            tag: '=',
            removeTag: '&',
            isInvalid: '=?',
            isDisabled: '<',
          },
          replace: true,
          template: '<div class="tagger-tag clearfix" ng-class="{ \'invalid-tag\': isInvalid, \'isDisabled\': isDisabled }">' +
                              '<div class="tagger-tag-text pull-left">{{tag}}</div>' +
                              '<div class="tagger-tag-btn pull-left" ng-click="removeTag()">' +
                                  '<i class="fa fa-times"></i>' +
                              '</div>' +
                          '</div>',
        }),
    );
})();
